import React from 'react'
import './header.css'
import INCSUBWhatsappBtn from '../../commonComponents/whatsappBtn/whatsappBtn';
import { useNavigate } from 'react-router-dom';

function INCSUBHeader( ) {
    const navigate = useNavigate()
    return (
        <div className='INCSUBHeader_ctn'>
            <div className='INCSUBHeader_ctn_left' onClick={ () => {
                navigate('/')
            }}>
                <img src='/sublogo.svg' alt="logo" />
            </div>
                <INCSUBWhatsappBtn />
        </div>
    )
}

export default INCSUBHeader;
